import { setCursor } from './utils';

// PZNs currently on the user's wishlist(s)
const wishlistPzns = new Set();

// TODO: consider caching the wishlist PZNs in sessionStorage to avoid one request per page load.
let wishlistPznsLoaded = false;

/**
 * Perform a leaflet RPC call.
 * @param {string} todo
 * @param {Object} [data]
 * @returns {Promise<Object>}
 */
async function leafletRequest(todo, data = {}) {
  const response = await fetch('/rpc.php?action=leaflet', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: new URLSearchParams({ todo, ...data }),
  });

  return response.json();
}

/**
 * Load the PZNs on the user's wishlist(s) once per page load.
 * @returns {Promise<void>}
 */
async function loadWishlistPzns() {
  try {
    const data = await leafletRequest('get-wishlist-pzns');

    if (!data || !Array.isArray(data.success)) {
      return;
    }

    wishlistPzns.clear();
    data.success.forEach((pzn) => wishlistPzns.add(Number(pzn)));
  } catch {
    // ignore, the buttons simply stay in their default state
  }
}

/**
 * Mark every wish button within the given scope according to the wishlist state.
 * @param {Element|Document} [root]
 */
export function applyWishlistState(root = document) {
  root.querySelectorAll('.addtoleafletbtn-global').forEach((btn) => {
    const isOnWishlist = wishlistPzns.has(Number(btn.value));

    btn.classList.toggle('is-on-wishlist', isOnWishlist);
    btn.querySelectorAll('.wishlist-label--add').forEach((label) => (label.hidden = isOnWishlist));
    btn.querySelectorAll('.wishlist-label--remove').forEach((label) => (label.hidden = !isOnWishlist));

    if (btn.dataset.wishlistLabelDefault === undefined) {
      btn.dataset.wishlistLabelDefault = btn.getAttribute('aria-label') || '';
    }

    btn.setAttribute('aria-label', isOnWishlist ? 'Vom Merkzettel entfernen' : btn.dataset.wishlistLabelDefault);
  });
}

/**
 * Mark a product as being on the wishlist after a successful add.
 * @param {string|number} pzn
 */
export function addWishlistPzn(pzn) {
  wishlistPzns.add(Number(pzn));
  applyWishlistState();
}

/**
 * Remove a product from every wishlist of the user.
 * @param {Element} btn
 */
async function removeFromWishlist(btn) {
  const pzn = Number(btn.value);
  setCursor('wait');

  try {
    const data = await leafletRequest('remove-wishlist-product', { id: pzn });

    if (!data || !data.success) {
      return;
    }

    wishlistPzns.delete(pzn);
    applyWishlistState();

    const $btn = $(btn);

    $btn.popover({
      content: 'Der Artikel wurde von ihrem Merkzettel entfernt',
      placement: 'top',
      title: 'Merkzettel',
      trigger: 'manual',
    });

    $btn.popover('show');

    $('body').one('click', () => {
      $btn.popover('hide');
    });
  } finally {
    setCursor('default');
  }
}

/**
 * Handle a click on a wish button that is already on the wishlist.
 * @param {Element} btn
 * @returns {boolean} true when the click was consumed as a removal
 */
export function handleWishlistButtonClick(btn) {
  if (!btn.classList.contains('is-on-wishlist')) {
    return false;
  }

  removeFromWishlist(btn);
  return true;
}

/**
 * Load and apply the wishlist state once per page load.
 */
export function initWishlist() {
  $(document).ready(() => {
    if (wishlistPznsLoaded) {
      applyWishlistState();
      return;
    }

    wishlistPznsLoaded = true;
    loadWishlistPzns().finally(() => applyWishlistState());
  });
}
